import { requestToServer } from "request-handler";
import { queryBuilder } from "utils";
import {
  IGETJobGroupsResponse,
  IGETPostsResponse,
  ISearchUser,
  IUserFullInfo,
  IUsersInfoResponse,
  IWard,
} from "./types";

export const POSTUserResendVerifyPhoneOtp = async (cell_phone: string) => {
  const result = await requestToServer<void>({
    method: "POST",
    url: `/v1/user/resendcode`,
    data: { cell_phone },
  });
  return result;
};

export const POSTUserVerifyPhone = async (
  username: string,
  sms_code: string
) => {
  const result = await requestToServer<void>({
    method: "POST",
    url: `/v1/user/verify`,
    data: {
      username,
      sms_code,
    },
  });
  return result;
};

export const POSTUserRecoveryPassword = async (cell_phone: string) => {
  const result = await requestToServer<void>({
    method: "POST",
    url: `/v1/user/resetpassword`,
    data: { cell_phone },
  });
  return result;
};

export const GETUserHospitalWardList = async () => {
  const result = await requestToServer<IWard[]>({
    method: "GET",
    url: `/v1/user/hospital/ward_lists`,
  });
  return result;
};

export const GETHospitalWardList = async ({
  hospitalId,
}: {
  hospitalId: string;
}) => {
  const result = await requestToServer<{
    result: IWard[];
  }>({
    method: "GET",
    url: `/v1/search_ward?hospital_id=${hospitalId}&query=`,
  });
  return result?.result;
};

export const GETSearchUsers = async ({
  hospitalId,
  query = "",
  post,
  job_location,
  job_group,
}: {
  hospitalId: string;
  query?: string;
  post?: string;
  job_location?: string;
  job_group?: string;
}) => {
  const params = queryBuilder(
    { hospital_id: hospitalId, post, job_location, query, job_group },
    false
  );
  const result = await requestToServer<{ result: ISearchUser[] }>({
    method: "GET",
    url: `/v1/search_user?${params}`,
  });
  return result?.result;
};

export const GETWardResponsibles = async () => {
  const result = await requestToServer<IUserFullInfo["me"][]>({
    method: "GET",
    url: `/v1/user/hospital/get_hospital_ward_responsibles`,
  });
  return result;
};

export const GETUserFullInfo = async () => {
  const result = await requestToServer<IUserFullInfo>({
    method: "GET",
    url: `/v1/user/me`,
  });
  return result;
};

export const POSTUsersInfo = async (data: { id: number[] }) => {
  const result = await requestToServer<IUsersInfoResponse>({
    method: "POST",
    url: `/v1/user/hospital/users`,
    data,
  });
  return result;
};

export const POSTUsersInfoCompact = async () => {
  const result = await requestToServer<IUsersInfoResponse>({
    method: "POST",
    url: `/v1/user/hospital/users`,
  });
  return result;
};

export const GETJobGroups = async () => {
  const result = await requestToServer<IGETJobGroupsResponse[]>({
    method: "GET",
    url: `/v1/hospital/job_groups`,
  });
  return result;
};

export const GETPosts = async () => {
  const result = await requestToServer<IGETPostsResponse>({
    method: "GET",
    url: `/v1/hospital/posts`,
  });
  return result;
};
